import React, { Fragment, useState, useEffect, useCallback } from 'react';
import {
    Row,
    Col,
    Card,
    Button,
    CustomInput,
    ListGroup,
    ListGroupItem,
    Container,
    Modal,
    ModalBody,
    ModalHeader
} from 'reactstrap';

import api from '../../../../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../../Context/Auth/AuthContext';

import NeedStatuses from '../../../../../enums/NeedStatuses';

export default function NeedsList(props) {
    const { role, activeTab } = props;

    const [needs, setNeeds] = useState([]);
    const { toggleLoading, currentGroup, authenticated } = useAuth();

    const [modalStatusAlert, setModalStatusAlert] = useState(false);
    const toggleModalStatusAlert = useCallback(() => {
        setModalStatusAlert(!modalStatusAlert);
    }, [setModalStatusAlert, modalStatusAlert]);

    useEffect(() => {
        const userInfo = () => {
            if (authenticated.user) {
                return authenticated.user;
            } else {
                return authenticated;
            }
        }

        if (JSON.parse(activeTab) === 7) {
            toggleLoading(true);
            api.post(`/ro.team.listNeedsForReceiver/${currentGroup.id}`, {
                receiverId: userInfo().id,
                minStatus: NeedStatuses.INSERTED,
                maxStatus: NeedStatuses.COMPLETED
            })
                .then((response) => {
                    setNeeds(response.data);
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                })
                .finally(() => {
                    toggleLoading(false);
                });
        }
    }, [role, toggleLoading, currentGroup, setNeeds, authenticated, activeTab]);

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col lg="12">
                        <Card className="main-card mb-3">
                            <ListGroup className="todo-list-wrapper" flush>
                                {needs &&
                                    needs.map((need) => (
                                        <ListGroupItem key={need.id}>
                                            <div className="widget-content p-0">
                                                <div className="widget-content-wrapper">
                                                    <div className="widget-content-left mr-2">
                                                        <CustomInput
                                                            type="checkbox"
                                                            id={`need-${need.id}`}
                                                            label="&nbsp;"
                                                            checked={need.status === NeedStatuses.COMPLETED}
                                                            onChange={toggleModalStatusAlert}
                                                        />
                                                    </div>
                                                    <div className="widget-content-left">
                                                        <div className="widget-heading">
                                                            {need.content}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ListGroupItem>
                                    ))}
                            </ListGroup>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={modalStatusAlert} toggle={toggleModalStatusAlert}>
                    <ModalHeader toggle={toggleModalStatusAlert}>
                        Alert
                    </ModalHeader>
                    <ModalBody>
                        <div className="text-center">
                            <p>
                                Only Coordinators can mark needs as completed.<br />
                                Please talk to your Coordinator.
                            </p>
                            <Button
                                className="btn-wide mb-2 mr-2"
                                size="md"
                                color="secondary"
                                onClick={toggleModalStatusAlert}
                            >
                                OK
                            </Button>
                        </div>
                    </ModalBody>
                </Modal>

            </Container>
        </Fragment>
    );
}
